export { EmailFormWrapper as EmailForm } from 'src/payments/signup/views/email-form';
export { PasswordFormWrapper as PasswordForm } from 'src/payments/signup/views/password-form';
export { SignUpFormWrapper as SignupForm } from 'src/payments/signup/views/signup-form';
export { ResetPasswordFormWrapper as ResetPasswordForm } from 'src/payments/signup/views/reset-password';
export { BankAccountSelector } from './bank-account-selector/bank-account-selector';
export { TermsForm as TermsView } from './terms';
export { DutchiePayLoadingView as Loading } from './loading';
export { UnsupportedAccount } from './unsupported-account';
export { AlreadySignedUp } from './already-signed-up';
